export default "__VITE_ASSET__eaa5709f__"